export default (): string => {
  const [registerId] = window.location.pathname.split('/').reverse()
  return registerId
}
